<template>
  <div id="app"
    :class="$i18n.locale"
  >
    <HeaderCompo />
    <template v-if="actualView === 'loading'">
      <b-loading
        is-full-page
        :active.sync="isLoading"
      >
        <div class="box loading">
          <div class="bloader">
            <div class="shape shape-1" />
            <div class="shape shape-2" />
            <div class="shape shape-3" />
            <div class="shape shape-4" />
          </div>
        </div>
      </b-loading>
    </template>
    <section
      id="content"
      class="section"
    >
      <NameCompo
        v-if="actualView === 'name'"
        :quiz-data="quizData"
        :q-id="qId"
        :user-id="userId"
        :new-user="newUser"
      />
      <ResultCompo
        v-if="actualView === 'result'"
        :score="score"
        :quiz-data="quizData"
      />
      <!-- <Ad4Compo
        v-if="actualView === 'result'"
      /> -->
      <ChartCompo
        v-if="actualView === 'result'"
        :quiz-data="quizData"
      />
      <InstaembedCompo
        v-if="actualView === 'result'"
      />
      <!-- <InstaCompo
        v-if="actualView === 'result'"
      /> -->
      <OwnerCompo
        v-if="actualView === 'owner'"
        :quiz-data="quizData"
        :q-id="qId"
        :user-id="userId"
      />
    </section>
    <FlyCompo />
    <FooterCompo />
    <!-- 728x90 sticky footer Desktop Only -->
    <!-- <div id="waldo-tag-15164" /> -->
    <div v-if="$isMobile()" />
    <div v-else>
      <!-- 300x600/160x600 sticky sidebar - Desktop Only-->
      <div class="sidebar-wrapper-left">
      </div>

      <!-- 300x600/160x600 Desktop Only -->
      <div class="sidebar-wrapper-right">
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCompo from '@/components/HeaderCompo.vue'
import FooterCompo from '@/components/FooterCompo.vue'
import NameCompo from '@/components/NameCompo.vue'
import FlyCompo from '@/components/FlyCompo.vue'
import ResultCompo from '@/components/ResultCompo.vue'
import ChartCompo from '@/components/ChartCompo.vue'
import OwnerCompo from '@/components/OwnerCompo.vue'
// import Ad4Compo from '@/components/Ad4Compo.vue'
// import InstaCompo from '@/components/InstaCompo.vue'
import InstaembedCompo from '@/components/InstaembedCompo.vue'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Q',
  components: {
    HeaderCompo,
    FooterCompo,
    NameCompo,
    FlyCompo,
    ResultCompo,
    ChartCompo,
    OwnerCompo,
    // Ad4Compo,
    // InstaCompo,
    InstaembedCompo
  },
  data () {
    return {
      actualView: 'loading',
      quizData: {
        answerers: []
      },
      userId: '',
      qId: '',
      newUser: false,
      score: '',
      isLoading: true
    }
  },
  created: function () {
    let pageURL = window.location.href
    let loc = pageURL.indexOf('q?=')
    let pollID
    if (loc === -1) {
      pollID = null
    } else {
      pollID = pageURL.substr(loc + 3, 5)
    }
    this.qId = pollID

    const that = this
    firebase.auth().signInAnonymously().catch(function (err) {
      // eslint-disable-next-line
      let errCode = err.code
      // eslint-disable-next-line
      let errMessage = err.message
    })
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let isAnon = user.isAnonymous
        if (isAnon) {
          // eslint-disable-next-line
          let anonymousUser = user
        }
        let userID = user.uid
        that.userId = userID
        // console.log(that.userId);

        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          // Send token to your backend via HTTPS
            // console.log(idToken)
          that.$http.defaults.headers.common = {'Authorization': `Bearer ${idToken}`}
          
          that.$http.get('https://bestiebackend.herokuapp.com/api/quizzes/' + pollID)
            .then(response => {
              if (response.data.quiz !== null) {
                that.quizData = response.data.quiz
                if (that.quizData.langloc === 'NA-EN') {
                  that.$i18n.locale = 'EN'
                } else if (that.quizData.langloc === 'NA-ES') {
                  that.$i18n.locale = 'ES'
                } else if (that.quizData.langloc === 'NA-FR') {
                  that.$i18n.locale = 'FR'
                } else if (that.quizData.langloc === 'LA-ES') {
                  that.$i18n.locale = 'ES'
                } else if (that.quizData.langloc === 'LA-PT') {
                  that.$i18n.locale = 'PT'
                } else if (that.quizData.langloc === 'LA-EN') {
                  that.$i18n.locale = 'EN'
                } else if (that.quizData.langloc === 'EU-EN') {
                  that.$i18n.locale = 'EN'
                } else if (that.quizData.langloc === 'EU-ES') {
                  that.$i18n.locale = 'ES'
                } else if (that.quizData.langloc === 'EU-NO') {
                  that.$i18n.locale = 'NO'
                } else if (that.quizData.langloc === 'EU-FR') {
                  that.$i18n.locale = 'FR'
                } else if (that.quizData.langloc === 'EU-PT') {
                  that.$i18n.locale = 'PT'
                } else if (that.quizData.langloc === 'EU-IT') {
                  that.$i18n.locale = 'IT'
                } else if (that.quizData.langloc === 'AS-EN') {
                  that.$i18n.locale = 'EN'
                }

                that.$http.get('https://bestiebackend.herokuapp.com/api/users/' + userID)
                  .then(response => {
                    // console.log(response)
                    if (response.data.user !== null) {
                      if (response.data.user.quiz_created_id) {
                        if (response.data.user.quiz_created_id === pollID) {
                          that.actualView = 'owner'
                          that.isLoading = false
                          // console.log(that.quizData)
                          // console.log('user owns this quiz')
                        } else {
                          if (response.data.user.quizes_given.some(item => item.qid === pollID)) {
                            // console.log('user has already taken the quiz')
                          } else {
                            that.actualView = 'name'
                            that.isLoading = false
                            // console.log('has user and quiz but not the owner')
                            // has user and quiz but not the owner
                          }
                        }
                      } else {
                        if (response.data.user.quizes_given.some(item => item.qid === pollID)) {
                          that.actualView = 'result'
                          that.isLoading = false
                          that.score = that.quizData.answerers.find(item => item.uid === userID).score
                          // console.log('user has already taken the quiz')
                        } else {
                          that.actualView = 'name'
                          that.isLoading = false
                          // console.log('has user but not quiz')
                          // has user and quiz but not the owner
                        }
                      }
                    } else {
                      that.newUser = true
                      that.actualView = 'name'
                      that.isLoading = false
                      // console.log(that.newUser)
                      // dont user saved
                    }
                  })
                  .catch(error => {
                    // get api/users call
                  })

              } else {
                alert(that.$t('quiz.notquiz'))
                setTimeout(() => {
                  window.location.href = '/'
                }, 1000)
                //   QUIZ DOESN'T EXIST
              }
            })
            .catch(error => {
              // get api/quizzes call
            })

        }).catch(function(error) {
          // firebase getIdToken call
        });

      } else {}
    })

  }
}
</script>

<style scoped>
.sidebar-wrapper-right, .sidebar-wrapper-left {
  position: fixed;
  text-align: center;
  z-index: 9999;
  margin-bottom: 0 !important;
  top: 50%;
  transform: translate(0, -50%);
}
.sidebar-wrapper-left {
  left: 0;
}
.sidebar-wrapper-right {
  right: 0;
}
</style>
